/**
 * StatusBadge — atom (CES standard)
 * State badge with semantic colors in the client portal's badge style
 * (soft background + strong text, e.g. bg-green-100 text-green-700).
 */

const STATE_CLASS: Record<string, string> = {
  // Asset states
  ACTIVE: 'bg-green-100 text-green-700',
  ISOLATED: 'bg-amber-100 text-amber-700',
  RETIRING: 'bg-red-100 text-red-700',
  INSTALLING: 'bg-blue-100 text-blue-700',
  // Capacity task statuses
  REQUESTED: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-blue-100 text-blue-700',
  COMPLETED: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
  WAITING_FOR_EVACUATION: 'bg-amber-100 text-amber-700',
  CANCELLATION_IN_PROGRESS: 'bg-amber-100 text-amber-700',
  CANCELLED: 'bg-gray-100 text-gray-600',
};

export function StatusBadge({ state }: { state?: string }) {
  const value = state ?? 'UNKNOWN';
  const variant = STATE_CLASS[value] ?? 'bg-gray-100 text-gray-600';
  return (
    <span
      className={`inline-block rounded px-2 py-1 text-xs font-semibold uppercase tracking-wide whitespace-nowrap ${variant}`}
    >
      {value}
    </span>
  );
}
